module.exports = __webpack_public_path__ + "media/components/Influencers/Reports/prev_arrow-3f8048f1f80b5a2bf841d21f681f3318.png";